<template>
	<IconBase icon-name="new">
		<path d="m 10,4 h 8 V 20 H 6 V 8 Z" class="blueStroke" />
		<path d="m 6,8 h 4 V 4" class="blueFill blueStroke" />
	</IconBase>
</template>

<script>
import IconBase from './IconBase';
export default {
	components: {
		IconBase
	}
};
</script>
